import { render } from "./NamedSlot.vue?vue&type=template&id=7cf25e43&scoped=true"
const script = {}

import "./NamedSlot.vue?vue&type=style&index=0&id=7cf25e43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf25e43"]])

export default __exports__